export default __webpack_public_path__ + "static/media/Rare_open.adbb9538.webm";